import CreativeApi from "../apis/creative";
import Vue from "vue";

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

// キャメルケースをスネークケースに変換するヘルパー
function camelToSnake(str) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

// choice_idフィールドの値を変換するヘルパー
// null → 空文字（APIで.presenceによりnilに変換される）、0はそのまま（ワイルドカード）
const CHOICE_ID_FIELDS = ['q1ChoiceId', 'q2ChoiceId', 'q3ChoiceId', 'q4ChoiceId', 'q5ChoiceId'];
// null を空文字に変換すべきフィールド（FormDataがnullを"null"文字列に変換するため）
const NULL_TO_EMPTY_FIELDS = [...CHOICE_ID_FIELDS, 'nextScenarioPopupId', 'iframeEmbedUrl', 'link'];

function convertChoiceIdValue(field, value) {
  if (NULL_TO_EMPTY_FIELDS.includes(field) && (value === null || value === undefined)) {
    return '';
  }
  return value;
}

// scenario_popup_patterns を FormData に追加する共通ヘルパー
function appendPatternsToFormData(formData, patterns, isEdit = false) {
  if (!patterns || patterns.length === 0) return;

  patterns.forEach((pattern, i) => {
    const patternCopy = { ...pattern };
    delete patternCopy.imageData;
    
    if (!isEdit && patternCopy.hasOwnProperty("id")) {
      delete patternCopy.id;
    }
    if (patternCopy.hasOwnProperty("image")) {
      delete patternCopy.image;
    }

    for (let field in patternCopy) {
      if (patternCopy.hasOwnProperty(field)) {
        const value = convertChoiceIdValue(field, patternCopy[field]);
        formData.append(
          `creative[scenario_popup_patterns_attributes][${i}][${camelToSnake(field)}]`,
          value
        );
      }
    }

    if (pattern.image) {
      formData.append(
        `creative[scenario_popup_patterns_attributes][${i}][image]`,
        pattern.image
      );
    }

    // 編集時のみ: 画像なしの場合（既存パターンのみ）、画像削除フラグを送信
    if (isEdit && !pattern.imageData && pattern.id) {
      formData.append(
        `creative[scenario_popup_patterns_attributes][${i}][remove_image]`,
        "1"
      );
    }
  });
}

export const state = () => ({
  lists: [],
  preview_list: {
    id: "",
    title: "",
    image: "",
    upload_image: "",
    is_upload_image: 1,
    pc_image: "",
    upload_pc_image: "",
    is_upload_pc_image: 1,
    common_image: "",
    upload_common_image: "",
    is_upload_common_image: 1,
    media_type: "image",
    iframe_embed_url: "",
    iframe_width_pc: 560,
    iframe_height_pc: 400,
    iframe_width_sp: 320,
    iframe_height_sp: 480,
    link: "",
    with_parameters: false,
    media_name: "",
    pr_flag: "",
    widget_id: "",
    pop_up_id: "",
    area_pop_up_id: "",
    overlay_id: "",
    close_btn_flag: false,
    arrow_btn_flag: false,
    powered_by_kenga: false,
    pop_up_animation: "fade_in",
    countdown: false,
    countdown_type: "day_end",
    countdown_bg_color: "#dd143c",
    countdown_font_color: "#ffffff",
    countdown_name: "default",
    prefix_countdown_text: "本日販売終了まで",
    time_limit_hour: 0,
    time_limit_min: 5,
    time_limit_hour: 1,
    time_limit: false,
    time_limit_type: "above",
    time_limit_val: 600,
    show_once: false,
    no_link: false,
    target_blank: true,
    inner_link: false,
    show_pc: false,
    show_sp: false,
    toggle_preview_pc: false,
    max_width: 500,
    limited_time: false,
    limited_time_from: "",
    limited_time_to: "",
    domain_check: false,
    specific_week_date: false,
    creative_display_week_dates: [
      { week_number: 1, times: [] },
      { week_number: 2, times: [] },
      { week_number: 3, times: [] },
      { week_number: 4, times: [] },
      { week_number: 5, times: [] },
      { week_number: 6, times: [] },
      { week_number: 7, times: [] }
    ],
    time_limit_specific_date: null,
    // 以下、シナリオ専用のデータ（これまで scenario_creative_form で管理していたもの）
    collections: [],
    current_collection: null,
    is_drawing: false,
    start_pos: { x: 0, y: 0 },
    current_area: { x: 0, y: 0, width: 0, height: 0 },
    show_preview: false,
    show_choice_settings: true,
    show_editor: true,
    result_images: [],
    show_result_image_upload: false,
    selected_question_id: null,
    selected_choice_id: null,
    loading_image: null,
    has_error: false,
    default_result_image: null,
    show_loading_image: false,
    choice_action: "add_scenario",
    delete_loading_image: false,
    scenario_popup_patterns: [],
  },
  tmp_list: {},
  delete_id: null,
  countdown_unix_time_left: 0,
  preview_upload_image_path: "",
  preview_upload_pc_image_path: ""
});

export const actions = {
  async search({ commit }, { widget_id }) {
    const { data } = await CreativeApi.search({ widget_id });
    commit("addLists", { creatives: data.creatives });
  },
  async create({ commit, state }) {
    const formData = new FormData();
    for (let key in state.preview_list) {
      if (
        state.preview_list.hasOwnProperty(key) &&
        state.preview_list[key] !== null
      ) {
        if (key === "creative_display_week_dates") {
          formData.append(key, JSON.stringify(state.preview_list[key]));
        } else {
          formData.append(key, state.preview_list[key]);
        }
      }
    }
    const { data } = await CreativeApi.create(formData);
    commit("clearPreviewList");
    commit("addLists", { creatives: [data] });
    return data;
  },
  async create_scenario({ commit, state }) {
    const formData = new FormData();

    // 親のシンプルなフィールド（キーは "creative[フィールド]"）
    const simpleKeys = [
      "link",
      "with_parameters",
      "pop_up_animation",
      "no_link",
      "target_blank",
      "inner_link",
      "show_pc",
      "show_sp",
      "max_width",
      "loading_image",
      "choice_action",
      "default_result_image",
      "scenario_popup_id",
      "delete_loading_image",
      "show_loading_image"
    ];
    simpleKeys.forEach(key => {
      if (state.preview_list[key] !== null) {
        formData.append(`creative[${key}]`, state.preview_list[key]);
      }
    });

    // collections を nested attributes 形式で追加
    state.preview_list.collections.forEach((collection, i) => {
      const collectionCopy = { ...collection };
      delete collectionCopy.imageData; // プレビュー用は除外

      // temp_id を送信（id がある場合はそれを使い、なければ元の temp_id を使用）
      const collectionTempId = collectionCopy.id || collectionCopy.temp_id;
      if (collectionTempId) {
        formData.append(`creative[scenario_images_attributes][${i}][temp_id]`, collectionTempId);
      }
      if (collectionCopy.hasOwnProperty("id")) {
        delete collectionCopy.id;
      }
      if (collectionCopy.hasOwnProperty("temp_id")) {
        delete collectionCopy.temp_id;
      }

      // 親レコードの name は除外
      if (collectionCopy.hasOwnProperty("name")) {
        delete collectionCopy.name;
      }

      // choices は後でネストするため一旦除外
      const choices = collectionCopy.choices;
      delete collectionCopy.choices;

      // ファイルアップロード用の image はループ外で追加するので除外する
      if (collectionCopy.hasOwnProperty("image")) {
        delete collectionCopy.image;
      }
      for (let field in collectionCopy) {
        if (collectionCopy.hasOwnProperty(field)) {
          formData.append(
            `creative[scenario_images_attributes][${i}][${camelToSnake(field)}]`,
            collectionCopy[field]
          );
        }
      }
      if (collection.image) {
        formData.append(
          `creative[scenario_images_attributes][${i}][image]`,
          collection.image
        );
      }

      // choices を nested attributes 形式で追加
      if (choices && Array.isArray(choices)) {
        choices.forEach((choice, j) => {
          const choiceCopy = { ...choice };
          delete choiceCopy.imageData; // プレビュー用は除外

          // temp_id を送信（id がある場合はそれを使い、なければ元の temp_id を使用）
          const choiceTempId = choiceCopy.id || choiceCopy.temp_id;
          if (choiceTempId) {
            formData.append(`creative[scenario_images_attributes][${i}][choices_attributes][${j}][temp_id]`, choiceTempId);
          }
          if (choiceCopy.hasOwnProperty("id")) {
            delete choiceCopy.id;
          }
          if (choiceCopy.hasOwnProperty("temp_id")) {
            delete choiceCopy.temp_id;
          }

          if (choiceCopy.hasOwnProperty("image")) {
            delete choiceCopy.image;
          }
          for (let chKey in choiceCopy) {
            if (choiceCopy.hasOwnProperty(chKey)) {
              formData.append(
                `creative[scenario_images_attributes][${i}][choices_attributes][${j}][${camelToSnake(chKey)}]`,
                choiceCopy[chKey]
              );
            }
          }
          if (choice.image) {
            formData.append(
              `creative[scenario_images_attributes][${i}][choices_attributes][${j}][image]`,
              choice.image
            );
          }
        });
      }
    });

    // scenario_popup_patterns を nested attributes 形式で追加（共通ヘルパー使用）
    appendPatternsToFormData(formData, state.preview_list.scenario_popup_patterns, false);

    const { data } = await CreativeApi.create_scenario(formData);
    commit("clearPreviewList");
    return data;
  },
  async edit_scenario({ commit, state }) {
    const formData = new FormData();

    // 親のシンプルなフィールド（キーは "creative[フィールド]"）
    const simpleKeys = [
      "id",
      "link",
      "with_parameters",
      "pop_up_animation",
      "no_link",
      "target_blank",
      "inner_link",
      "show_pc",
      "show_sp",
      "max_width",
      "loading_image",
      "choice_action",
      "default_result_image",
      "scenario_popup_id",
      "delete_loading_image"
    ];
    simpleKeys.forEach(key => {
      if (state.preview_list[key] !== null) {
        formData.append(`creative[${key}]`, state.preview_list[key]);
      }
    });

    // collections を nested attributes 形式で追加
    state.preview_list.collections.forEach((collection, i) => {
      const collectionCopy = { ...collection };
      delete collectionCopy.imageData; // プレビュー用は除外

      // 親レコードの name は除外
      if (collectionCopy.hasOwnProperty("name")) {
        delete collectionCopy.name;
      }

      // choices は後でネストするため一旦除外
      const choices = collectionCopy.choices;
      delete collectionCopy.choices;

      // ファイルアップロード用の image はループ外で追加するので除外する
      if (collectionCopy.hasOwnProperty("image")) {
        delete collectionCopy.image;
      }
      for (let field in collectionCopy) {
        if (collectionCopy.hasOwnProperty(field)) {
          formData.append(
            `creative[scenario_images_attributes][${i}][${camelToSnake(field)}]`,
            collectionCopy[field]
          );
        }
      }
      if (collection.image) {
        formData.append(
          `creative[scenario_images_attributes][${i}][image]`,
          collection.image
        );
      }

      // choices を nested attributes 形式で追加
      if (choices && Array.isArray(choices)) {
        choices.forEach((choice, j) => {
          const choiceCopy = { ...choice };
          delete choiceCopy.imageData; // プレビュー用は除外

          if (choiceCopy.hasOwnProperty("image")) {
            delete choiceCopy.image;
          }
          for (let chKey in choiceCopy) {
            if (choiceCopy.hasOwnProperty(chKey)) {
              formData.append(
                `creative[scenario_images_attributes][${i}][choices_attributes][${j}][${camelToSnake(chKey)}]`,
                choiceCopy[chKey]
              );
            }
          }
          if (choice.image) {
            formData.append(
              `creative[scenario_images_attributes][${i}][choices_attributes][${j}][image]`,
              choice.image
            );
          }
        });
      }
    });

    // scenario_popup_patterns を nested attributes 形式で追加（共通ヘルパー使用）
    appendPatternsToFormData(formData, state.preview_list.scenario_popup_patterns, true);

    const { data } = await CreativeApi.edit_scenario(formData);
    commit("clearPreviewList");
    return data;
  },
  async create_demo({ commit, state }) {
    const params = state.preview_list;
    const data = Object.assign({}, params);
    commit("clearPreviewList");
    commit("addLists", { creatives: [data] });
    return data;
  },
  async find_edit_mode_and_update({ commit, state }) {
    const editable_list = find_edit_mode(state.lists);
    const formData = new FormData();
    for (let key in editable_list) {
      if (
        editable_list.hasOwnProperty(key) &&
        editable_list[key] !== null
      ) {
        formData.append(key, editable_list[key]);
      }
    }
    commit("setEditModeOff");
  },
  async update({ commit, state }) {
    const formData = new FormData();
    for (let key in state.preview_list) {
      if (
        state.preview_list.hasOwnProperty(key) &&
        state.preview_list[key] !== null
      ) {
        if (key === "creative_display_week_dates") {
          formData.append(key, JSON.stringify(state.preview_list[key]));
        } else {
          formData.append(key, state.preview_list[key]);
        }
      }
    }
    const { data } = await CreativeApi.update(formData);
    commit("clearPreviewList");
    commit("addLists", { creatives: [data] });
    return data;
  },
  async destroy({ commit, state }, { widget_id }) {
    const { data } = await CreativeApi.destroy({
      id: state.delete_id,
      widget_id
    });
    commit("removeList", state.delete_id);
    commit("setDeleteId", null);
  },
  async updateOrder({ commit, state }, { lists }) {
    const data = lists.map((list, idx) => ({
      id: list.id,
      idx
    }));
    await CreativeApi.update_order({ lists: data });
    commit("setLists", lists);
  }
};

export const mutations = {
  addLists(state, { creatives }) {
    for (let creative of creatives) {
      if (typeof creative !== "undefined") {
        // pc
        Vue.set(creative, "is_upload_pc_image", 0);
        Vue.set(creative, "upload_pc_image", "");
        Vue.set(creative, "upload_pc_image_path", "");
        Vue.set(creative, "edit_mode_pc", false);
        // sp
        Vue.set(creative, "is_upload_image", 0);
        Vue.set(creative, "upload_image", "");
        Vue.set(creative, "upload_image_path", "");
        Vue.set(creative, "edit_mode", false);
        state.lists.unshift(creative);
      }
    }
  },
  setLists(state, lists) {
    state.lists = lists;
  },
  setPreviewListId(state, id) {
    state.preview_list.id = id;
  },
  setPreviewListTitle(state, title) {
    state.preview_list.title = title;
  },
  setPreviewListIsUploadImage(state, is_upload_image) {
    state.preview_list.is_upload_image = is_upload_image;
  },
  setPreviewListImage(state, image) {
    state.preview_list.image = image;
  },
  setPreviewListUploadImage(state, file) {
    state.preview_list.upload_image = file;
  },
  setPreviewListIsUploadPcImage(state, is_upload_pc_image) {
    state.preview_list.is_upload_pc_image = is_upload_pc_image;
  },
  setPreviewListPcImage(state, image) {
    state.preview_list.pc_image = image;
  },
  setPreviewListUploadPcImage(state, file) {
    state.preview_list.upload_pc_image = file;
  },
  setPreviewListIsUploadCommonImage(state, is_upload_common_image) {
    state.preview_list.is_upload_image = is_upload_common_image;
    state.preview_list.is_upload_pc_image = is_upload_common_image;
    state.preview_list.is_upload_common_image = is_upload_common_image;
  },
  setPreviewListCommonImage(state, common_image) {
    state.preview_list.image = common_image;
    state.preview_list.pc_image = common_image;
    state.preview_list.common_image = common_image;
  },
  setPreviewListUploadCommonImage(state, common_file) {
    state.preview_list.upload_image = common_file;
    state.preview_list.upload_pc_image = common_file;
  },
  setPreviewListMediaType(state, media_type) {
    state.preview_list.media_type = media_type;
  },
  setPreviewListIframeEmbedUrl(state, iframe_embed_url) {
    state.preview_list.iframe_embed_url = iframe_embed_url;
  },
  setPreviewListIframeWidthPc(state, iframe_width_pc) {
    state.preview_list.iframe_width_pc = iframe_width_pc;
  },
  setPreviewListIframeHeightPc(state, iframe_height_pc) {
    state.preview_list.iframe_height_pc = iframe_height_pc;
  },
  setPreviewListIframeWidthSp(state, iframe_width_sp) {
    state.preview_list.iframe_width_sp = iframe_width_sp;
  },
  setPreviewListIframeHeightSp(state, iframe_height_sp) {
    state.preview_list.iframe_height_sp = iframe_height_sp;
  },
  setPreviewListLink(state, link) {
    state.preview_list.link = link;
  },
  setWithParameters(state, with_parameters) {
    state.preview_list.with_parameters = with_parameters;
  },
  setPreviewListMediaName(state, media_name) {
    state.preview_list.media_name = media_name;
  },
  setPreviewListPrFlag(state, pr_flag) {
    state.preview_list.pr_flag = pr_flag;
  },
  setPreviewListWidgetId(state, widget_id) {
    state.preview_list.widget_id = widget_id;
  },
  setPreviewListPopUpId(state, pop_up_id) {
    state.preview_list.pop_up_id = pop_up_id;
  },
  setPreviewListAreaPopUpId(state, area_pop_up_id) {
    state.preview_list.area_pop_up_id = area_pop_up_id;
  },
  setPreviewListOverlayId(state, overlay_id) {
    state.preview_list.overlay_id = overlay_id;
  },
  setPreviewListCloseBtnFlag(state, close_btn_flag) {
    state.preview_list.close_btn_flag = close_btn_flag;
  },
  setPreviewListArrowBtnFlag(state, arrow_btn_flag) {
    state.preview_list.arrow_btn_flag = arrow_btn_flag;
  },
  setPreviewListPoweredByKenga(state, powered_by_kenga) {
    state.preview_list.powered_by_kenga = powered_by_kenga;
  },
  setPreviewUploadImagePath(state, url) {
    state.preview_upload_image_path = url;
  },
  setPreviewUploadPcImagePath(state, url) {
    state.preview_upload_pc_image_path = url;
  },
  setPreviewListPopUpMaxWidth(state, width) {
    state.preview_list.max_width = width;
    console.log("state.preview_list.max_width ", state.preview_list.max_width);
  },
  setCountdown(state, countdown) {
    state.preview_list.countdown = countdown;
  },
  setCountdownType(state, countdown_type) {
    state.preview_list.countdown_type = countdown_type;
  },
  setCountBgColor(state, hex) {
    state.preview_list.countdown_bg_color = hex;
  },
  setCountFontColor(state, hex) {
    state.preview_list.countdown_font_color = hex;
  },
  setCountdownName(state, name) {
    state.preview_list.countdown_name = name;
  },
  setPrefixCountdownText(state, name) {
    state.preview_list.prefix_countdown_text = name;
  },
  setTimeLimitMin(state, min) {
    state.preview_list.time_limit_min = min;
  },
  setTimeLimitHour(state, hour) {
    state.preview_list.time_limit_hour = hour;
  },
  setTimeLimitSpecificDate(state, date) {
    console.log("setTimeLimitSpecificDate", date);
    state.preview_list.time_limit_specific_date = date;
  },
  setPreviewListShowOnce(state, show_once) {
    state.preview_list.show_once = show_once;
  },
  setPreviewListShowPc(state, show_pc) {
    state.preview_list.show_pc = show_pc;
  },
  setPreviewListShowSp(state, show_sp) {
    state.preview_list.show_sp = show_sp;
  },
  setPreviewListTogglePreviewPc(state, toggle_preview_pc) {
    state.preview_list.toggle_preview_pc = toggle_preview_pc;
  },
  setEditListTitle(state, title) {
    state.lists.filter((list) => list.edit_mode)[0].title = title;
  },
  setEditListIsUploadImage(state, is_upload_image) {
    state.lists.filter((list) => list.edit_mode)[0].is_upload_image = is_upload_image;
  },
  setEditListImage(state, image) {
    state.lists.filter((list) => list.edit_mode)[0].image = image;
  },
  setEditListUploadImage(state, file) {
    state.lists.filter((list) => list.edit_mode)[0].upload_image = file;
  },
  setEditListLink(state, link) {
    state.lists.filter((list) => list.edit_mode)[0].link = link;
  },
  setEditListMediaName(state, media_name) {
    state.lists.filter((list) => list.edit_mode)[0].media_name = media_name;
  },
  setEditListPrFlag(state, pr_flag) {
    state.lists.filter((list) => list.edit_mode)[0].pr_flag = pr_flag;
  },
  setEditListUploadImagePath(state, url) {
    state.lists.filter((list) => list.edit_mode)[0].upload_image_path = url;
  },
  setDeleteId(state, id) {
    state.delete_id = id;
  },
  setCountdownUnixTimeLeft(state) {
    state.countdown_unix_time_left =
      new Date().getTime() +
      state.preview_list.time_limit_hour * 60 * 60 * 1000 +
      state.preview_list.time_limit_min * 60 * 1000;
  },
  setCountdownUnixTimeLeftFromSpecificDate(state) {
    const specificDate = new Date(state.preview_list.time_limit_specific_date);
    state.countdown_unix_time_left = specificDate.getTime();
  },
  setTimeLimit(state, bool) {
    state.preview_list.time_limit = bool;
  },
  setDomainCheck(state, bool) {
    state.preview_list.domain_check = bool;
  },
  setTimeLimitType(state, str) {
    state.preview_list.time_limit_type = str;
  },
  setTimeLimitVal(state, i) {
    state.preview_list.time_limit_val = i;
  },
  setLimitedTime(state, bool) {
    state.preview_list.limited_time = bool;
  },
  setLimitedTimeFrom(state, str) {
    state.preview_list.limited_time_from = str;
  },
  setLimitedTimeTo(state, str) {
    state.preview_list.limited_time_to = str;
  },
  setSpecificWeekDate(state, bool) {
    state.preview_list.specific_week_date = bool;
  },
  setHideHoliday(state, bool) {
    state.preview_list.hide_holiday = bool;
  },
  addCreativeDisplayWeekDate(state, week_number) {
    const weekDate = state.preview_list.creative_display_week_dates.find(
      (date) => date.week_number === week_number
    );
    if (!weekDate) {
      state.preview_list.creative_display_week_dates.push({
        week_number: week_number,
        times: []
      });
    }
  },
  addCreativeDisplayWeekDateTime(state, { week_number, time }) {
    console.log("week_number", week_number);
    console.log("time", time);
    const weekDate = state.preview_list.creative_display_week_dates.find(
      (date) => date.week_number === week_number
    );
    if (weekDate) {
      weekDate.times.push(time);
    }
  },
  emptyCreativeDisplayWeekDateTime(state, { week_number }) {
    const weekDate = state.preview_list.creative_display_week_dates.find(
      (date) => date.week_number === week_number
    );
    if (weekDate) {
      weekDate.times = [];
    }
  },
  removeCreativeDisplayWeekDateTime(state, { week_number, time_index }) {
    const weekDate = state.preview_list.creative_display_week_dates.find(
      (date) => date.week_number === week_number
    );
    if (weekDate) {
      weekDate.times.splice(time_index, 1);
      if (weekDate.times.length === 0) {
        weekDate.times = [];
      }
    }
  },
  removeList(state, id) {
    state.lists = state.lists.filter((list) => list.id != id);
  },
  clearPreviewList(state) {
    state.preview_list.title = "";
    state.preview_list.image = "";
    state.preview_list.link = "";
    state.preview_list.media_name = "";
    state.preview_list.pr_flag = "";
    state.preview_list.upload_image = "";
    state.preview_list.upload_pc_image = "";
    state.preview_list.media_type = "image";
    state.preview_list.iframe_embed_url = "";
    state.preview_list.iframe_width_pc = 560;
    state.preview_list.iframe_height_pc = 400;
    state.preview_list.iframe_width_sp = 320;
    state.preview_list.iframe_height_sp = 480;
    state.preview_upload_image_path = "";
    state.preview_upload_pc_image_path = "";
    // シナリオ専用のパラメーターもクリア
    state.preview_list.collections = [];
    state.preview_list.current_collection = null;
    state.preview_list.is_drawing = false;
    state.preview_list.start_pos = { x: 0, y: 0 };
    state.preview_list.current_area = { x: 0, y: 0, width: 0, height: 0 };
    state.preview_list.show_preview = false;
    state.preview_list.show_choice_settings = true;
    state.preview_list.show_editor = true;
    state.preview_list.result_images = [];
    state.preview_list.show_result_image_upload = false;
    state.preview_list.selected_question_id = null;
    state.preview_list.selected_choice_id = null;
    state.preview_list.loading_image = null;
    state.preview_list.has_error = false;
    state.preview_list.default_result_image = null;
    state.preview_list.show_loading_image = false;
    state.preview_list.choice_action = "add_scenario";
  },
  setEditMode(state, list) {
    state.lists.map((list) => {
      list.edit_mode = false;
    });
    state.tmp_list = Vue.util.extend({}, list);
    list.edit_mode = true;
  },
  copy(state, creative) {
    state.preview_list.title = creative.title;
    state.preview_list.image = creative.image;
    state.preview_list.pc_image = creative.pc_image;
    state.preview_list.link = creative.link;
    state.preview_list.media_name = creative.media_name;
    state.preview_list.pr_flag = creative.pr_flag;
    state.preview_list.iframe_embed_url = creative.iframe_embed_url || "";
    state.preview_list.iframe_width_pc = creative.iframe_width_pc || 560;
    state.preview_list.iframe_height_pc = creative.iframe_height_pc || 400;
    state.preview_list.iframe_width_sp = creative.iframe_width_sp || 320;
    state.preview_list.iframe_height_sp = creative.iframe_height_sp || 480;
    state.preview_list.media_type = creative.iframe_embed_url ? "iframe" : "image";
  },
  setEditModeOff(state) {
    state.lists.map((list) => {
      list.edit_mode = false;
      list.is_upload_image = 0;
      list.upload_image = "";
      list.upload_image_path = "";
    });
  },
  clearEditMode(state, list) {
    list.title = state.tmp_list.title;
    list.image = state.tmp_list.image;
    list.link = state.tmp_list.link;
    list.media_name = state.tmp_list.media_name;
    list.pr_flag = state.tmp_list.pr_flag;
    list.edit_mode = false;
    list.is_upload_image = 0;
    list.upload_image = "";
    list.upload_image_path = "";
  },
  sortList(state, { old_idx, new_idx }) {
    array_move(state.lists, old_idx, new_idx);
  },
  setPreviewListPopUpAnimation(state, pop_up_animation) {
    state.preview_list.pop_up_animation = pop_up_animation;
  },
  setPreviewListNoLink(state, no_link) {
    state.preview_list.no_link = no_link;
  },
  setPreviewListTargetBlank(state, target_blank) {
    state.preview_list.target_blank = target_blank;
  },
  setPreviewListInnerLink(state, inner_link) {
    state.preview_list.inner_link = inner_link;
  },
  /**
   * 汎用ミューテーション：シナリオ専用項目を更新する
   * payload: { field, value }
   * 対象フィールド: collections, current_collection, is_drawing, start_pos,
   * current_area, show_preview, show_choice_settings, show_editor, result_images,
   * show_result_image_upload, selected_question_id, selected_choice_id,
   * loading_image, has_error, default_result_image, show_loading_image, choice_action
   */
  updateScenarioField(state, { field, value }) {
    const allowedFields = [
      "id",
      "collections",
      "current_collection",
      "is_drawing",
      "start_pos",
      "current_area",
      "show_preview",
      "show_choice_settings",
      "show_editor",
      "result_images",
      "show_result_image_upload",
      "selected_question_id",
      "selected_choice_id",
      "loading_image",
      "has_error",
      "default_result_image",
      "show_loading_image",
      "choice_action",
      "scenario_popup_id",
      "default_auto_transition",
      "default_with_parameters",
      "scenario_popup_patterns"
    ];
    if (allowedFields.includes(field)) {
      state.preview_list[field] = value;
    } else {
      console.warn(`Field ${field} is not a valid scenario field in preview_list.`);
    }
  },
  updateChoiceAnimation(state, { collectionId, choiceId, animationImage, animationImagePreview }) {
    const collection = state.preview_list.collections.find(c => c.id === collectionId || c.temp_id === collectionId);
    if (collection) {
      const choice = collection.choices.find(ch => ch.id === choiceId || ch.temp_id === choiceId);
      if (choice) {
        choice.animationImage = animationImage;
        choice.animationImagePreview = animationImagePreview;
      }
    }
  },
  deleteChoiceAnimation(state, { collectionId, choiceId }) {
    const collection = state.preview_list.collections.find(c => c.id === collectionId || c.temp_id === collectionId);
    if (collection) {
      const choice = collection.choices.find(ch => ch.id === choiceId || ch.temp_id === choiceId);
      if (choice) {
        choice.animationImage = null;
        choice.animationImagePreview = null;
      }
    }
  },
  setDeleteLoadingImage(state, value) {
    state.preview_list.delete_loading_image = value;
  },
};

export const getters = {
  findEdit(state) {
    return find_edit_mode(state.lists);
  },
  countdownTimeLimitSec(state) {
    return state.preview_list.time_limit_min * 60;
  }
};

function find_edit_mode(lists) {
  return lists.filter((list) => list.edit_mode)[0];
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
